import withAreasDictado from "../../hoc/withTrabajadores/withAreasDictado";
import AreasDictado from "../../view/components/RegistroUsuarios/Clasificacion/EditarTemasArea/AreasDictado";

export default withAreasDictado(AreasDictado);